import React from 'react';
import StarRating from 'react-star-ratings';


//[1,4,6,7]
//1+4 =5
//5+6=11
//11 + 7= 18

export const showAverage=(p)=>{
    if(p && p.ratings){
        let ratingsArray = p && p.ratings
        let total= []
        let length=ratingsArray.length

        ratingsArray.map((r)=> total.push(r.star))
        // 1 4 6 7, so what reduce does is first adds 1 and 4 then 5 + 6 then 11 + 7 until the end
        //0 is the intial value
        let totalReduced = total.reduce((p, n)=> p + n, 0)
        //console.log(totalReduced)
        //get the highest possible result
        let highest = length * 5
        //console.log('Hightest Possible',highest)
        let result = (totalReduced *5)/highest
        //console.log("result", result)

        return (   
            <div className="text-center pt-1 pb-3">
                <span >
                    <StarRating 
                    starDimension="20px" 
                    starSpacing="2px" 
                    starRatedColor="gold" 
                    rating={result} 
                    editing={false} /> 
                    ({p.ratings.length})
                </span>
            </div>
        )
    }
}




export const showAverageNumber=(p)=>{
    if(p && p.ratings){
        let ratingsArray = p && p.ratings
        let total= []
        let length=ratingsArray.length

        ratingsArray.map((r)=> total.push(r.star))
        // 1 4 6 7, so what reduce does is first adds 1 and 4 then 5 + 6 then 11 + 7 until the end
        //0 is the intial value
        let totalReduced = total.reduce((p, n)=> p + n, 0)
        //console.log(totalReduced)
        //get the highest possible result
        let highest = length * 5
        //console.log('Hightest Possible',highest)
        let result = (totalReduced *5)/highest
        //console.log("result", result)
        return (   
            result
        )
    }else{
        return(0)
    }
}